import { useEffect, useState } from "react";
import { Footer } from "@/components/layout/Footer";
import { fetchAPI } from "@/lib/api";

export default function PrivacyPolicy() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAPI("?type=legal&key=privacy_policy")
      .then((data: any) => {
        setContent(data.content);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching privacy policy:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="container mx-auto px-6 lg:px-8 py-32 flex-1">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-8">Privacy Policy</h1>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <div 
            className="prose prose-lg dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: content }} 
          />
        )}
      </div>
      <Footer />
    </div>
  );
}
